import scheduleCreate from './schedule-create'
import scheduleAssign from './schedule-assign'

export default {
  schedule: {
    namespaced: true,
    modules: {
      'schedule-create': scheduleCreate,
      'schedule-assign': scheduleAssign
    }
  }
}
